import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import TabScrollButton from '@mui/material/TabScrollButton';
import { styled } from '@mui/material/styles';

const ScrollButtonFade = ({
  direction,
  disabled,
  backgroundcolor = 'var(--trashie-ui-faded-black-10)',
}) => (
  <Box
    className="scrollButtons-fade"
    sx={theme => ({
      width: '60px',
      backgroundImage: direction === 'right' ? (
        `linear-gradient(to right, rgb(255 255 255 / 0), ${backgroundcolor} 40px)`
      ) : (
        `linear-gradient(to right, ${backgroundcolor} 20px, rgb(255 255 255 / 0))`
      ),
      position: 'absolute',
      zIndex: -1,
      ...(direction === 'right' ? { right: '40px' } : { left: '40px' }),
      ...(disabled ? { display: 'none' } : {}),
      [theme.breakpoints.down(1020)]: {
        ...(direction === 'right' ? { right: '40px' } : {}),
        backgroundImage: 'none',
      },
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    })}
  />
);

const ScrollButtonComponent = (props) => (
  <Box
    sx={{
      display: 'flex',
      opacity: 1,
      zIndex: 1,
    }}
  >
    <ScrollButtonFade {...props} />
    <TabScrollButton {...props} />
  </Box>
);

const StyledCategoryTabs = styled((props) => (
  <Tabs
    {...props}
    ScrollButtonComponent={ScrollButtonComponent}
    TabScrollButtonProps={{
      backgroundcolor: props.backgroundcolor,
    }}
  />
))({
  backgroundcolor: 'inherit',
  minHeight: '0px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiSvgIcon-root': {
    fill: 'var(--trashie-ui-faded-black-100-b)',
  },
  '& .MuiTabs-scrollButtons': {
    border: '1px solid var(--trashie-ui-faded-black-30)',
    borderRadius: '50%',
    height: '1.5rem',
    width: '1.5rem',
    alignSelf: 'center',
    margin: '0 2px',
    '&:hover, &.Mui-focusVisible': {
      transform: 'scale(1.04)',
      boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    },
  },
  '& .Mui-disabled': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: '1rem',
    '@media (max-width: 1020px)': {
      gap: '0.5rem',
    },
  },
  '& .MuiTabs-root': {
    minHeight: '0px',

    gap: '1rem',
    '@media (max-width: 1020px)': {
      gap: '0.5rem',
    },
  },

});

export default StyledCategoryTabs;
